
import {Issuer} from "@/model/Issuer";
import Vue, {PropType} from "vue";
import LogoEdit from "@/components/LogoEdit.vue";

export default Vue.extend({
  components: {LogoEdit},
  props: {
    label: String,
    model: {
      required: true,
      type: Object as PropType<Issuer>
    },
    isdummy: Boolean,
    HasNoEditRights: Boolean,
    expanded: {
      required: false,
      type: Array as PropType<Array<number>>,
      default() {
        return [1]
      }
    },
  },
  data: function () {
    return {
      maximumImageWidth: 1920,
      maximumImageHeight: 1280,
      dpi: 300,
      internalExpand: [1]
    };
  },
  mounted() {
    this.internalExpand = this.expanded;
  },
  watch: {
    expanded: function (value){
      this.internalExpand = value;
    }
  },
});
